import { Dialog as BaseDialog } from '@base-ui/react/dialog';
import styles from './index.module.scss';
import { ComponentProps, useCallback } from 'react';
import { classNames } from '@/utils/ui/classname';

interface ModalDialogProps extends React.ComponentProps<typeof BaseDialog.Root> {
  children?: React.ReactNode;
  popupClassName?: string;
}

type TOpenChangeHandler = Required<ComponentProps<typeof BaseDialog.Root>>['onOpenChange'];

export function ModalDialog({ children, popupClassName, onOpenChange, ...props }: ModalDialogProps) {
  const handleOpenChangeWithEscPreventation: TOpenChangeHandler = useCallback(
    (open, eventDetail) => {
      if (!open && eventDetail.reason === 'escape-key') {
        eventDetail.cancel();
        return;
      }
      onOpenChange?.(open, eventDetail);
    },
    [onOpenChange]
  );
  return (
    <BaseDialog.Root {...props} onOpenChange={handleOpenChangeWithEscPreventation} disablePointerDismissal>
      <BaseDialog.Portal>
        <BaseDialog.Backdrop className={styles.backdrop} />
        <BaseDialog.Popup className={classNames(styles.popup, popupClassName)}>{children}</BaseDialog.Popup>
      </BaseDialog.Portal>
    </BaseDialog.Root>
  );
}
